'use strict';
import {createActions} from '../../framework';

const normalActions = ['RESET_STORE', 'SET_SELECTED_ITEM', 'SET_STORE_NAME'];

const radioButtonGroupActions = createActions(null, normalActions);

export default radioButtonGroupActions;
